import { Component } from '@angular/core';
import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_accessibility from 'highcharts/modules/accessibility';
import * as Highcharts from 'highcharts';

HC_more(Highcharts);
HC_exporting(Highcharts);
HC_exportData(Highcharts);
HC_accessibility(Highcharts);

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent {
  raceData = [
    { name: 'Category 1', y: 10, color: '#0099a9' },
    { name: 'Category 2', y: 20, color: 'red' },
    { name: 'Category 3', y: 30, color: 'orange' },
    // Add more categories here if needed
  ];


  constructor() { }

  ngOnInit(): void {
    this.createChart();
  }

  createChart() {
    Highcharts.chart('donut', {
      chart: {
        type: 'pie'
      },
      title: {
        text: 'Donut Chart'
      },
      plotOptions: {
        pie: {
          innerSize: '50%', // Set inner size to make it a donut chart
          depth: 45, // Adjust depth for 3D effect if desired
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}:</b> {point.y}'
          }
        }
      },
      series: [{
        name: 'Categories',
        data: this.raceData,
        type: 'pie'
      }],
      tooltip: {
        valueDecimals: 2,
        valueSuffix: ' TWh'
      },
      exporting: {
        enabled: false, 
      },
      credits: {
        enabled: false
      }
    });
  }
}
